
import * as React from "react";
import { styled } from "@mui/material/styles";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Stack } from "@mui/material";

const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isHovered",
})(({ theme, isSelected, isHovered, day }) => ({
  borderRadius: 0,
  ...(isSelected && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary.main,
    },
  }),
  ...(isHovered && {
    backgroundColor: theme.palette.primary.light,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary.light,
    },
  }),
  ...(day.day() === 0 && {
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
  }),
  ...(day.day() === 6 && {
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
  }),
}));

const isInSameWeek = (dayA, dayB) => {
  if (!dayB) {
    return false;
  }
  return dayA.isSame(dayB, "week");
};

function Day(props) {
  const { day, selectedDay, hoveredDay, ...other } = props;
  return (
    <CustomPickersDay
      {...other}
      day={day}
      sx={{ px: 2.5 }}
      disableMargin
      selected={false}
      isSelected={isInSameWeek(day, selectedDay)}
      isHovered={isInSameWeek(day, hoveredDay)}
    />
  );
}

export function WeekPicker({ onApply, onCancel }) {
  const [hoveredDay, setHoveredDay] = React.useState(null);
  const [value, setValue] = React.useState(dayjs(new Date()));
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);

  const handleDateChange = (newValue) => {
    if (newValue) {
      setValue(newValue);
      const startOfWeek = newValue.startOf("week").format("YYYY-MM-DD");
      const endOfWeek = newValue.endOf("week").format("YYYY-MM-DD");

      setStartDate(startOfWeek);
      setEndDate(endOfWeek);

      //console.log("Start of Week:", startOfWeek);
      //console.log("End of Week:", endOfWeek);
      // onApply({ from_date: startDate, to_date: endDate });
      // onApply({ from_date: startOfWeek, to_date: endOfWeek });
    }
  };

  const handleApply = () => {
    if (startDate && endDate) {
      onApply({ from_date: startDate, to_date: endDate });
    }
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    onCancel();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="column" spacing={2}>
        <DateCalendar
          value={value}
          onChange={handleDateChange}
          showDaysOutsideCurrentMonth
          displayWeekNumber
          slots={{ day: Day }}
          slotProps={{
            day: (ownerState) => ({
              selectedDay: value,
              hoveredDay,
              onPointerEnter: () => setHoveredDay(ownerState.day),
              onPointerLeave: () => setHoveredDay(null),
            }),
          }}
        />
        <div className="d-flex gap-3 ">
          <button type="button" className="add_btn" onClick={handleApply}>
            Submit
          </button>
          <button type="button" className="cancel_btn" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </Stack>
    </LocalizationProvider>
  );
}

